<footer>
  @if (extendedVersion()) {
    <div class="footer-logo"><img src="assets/images/biavl-logo-blue-128.png"></div>
    <div class="footer-info">
      <h4>hivelog.dk</h4>
      DANMARKS BIAVLERFORENING
      <br />Created by Danmarks Biavlerforening
    </div>
    <div class="footer-about">
      <h4>About</h4>
      <a href="https://hivelog.dk">hivelog.dk</a>
      <br /><a href="https://bilab.dk">bilab.dk</a>
      <br /><a href="https://www.biavl.dk/">www.biavl.dk</a>
      <p><small>v. {{version}}</small></p>
    </div>
    <div class="footer-language">
      <h4>Language</h4>
      <app-language-select></app-language-select>
    </div>
  } @else {
    <small>hivelog.dk {{ version }}</small>
  }




</footer>